import { createSelector } from "reselect";

import { get } from "lodash";
import { getSubLineItems, getSubLineItemsById } from "./subLineItems";
import { getRuleSets } from "./productRules";

export const getRulesForFnSelector = ruleSets => {
  return (productGroupId, productId) => {
    return ruleSets.reduce((accu, ruleSet) => {
      if (ruleSet.product_group_when == productGroupId) {
        ruleSet.rules.forEach(rule => {
          const productIds = rule.when.product.id;

          if (productIds.includes(productId)) {
            accu.push({
              product_group_when: ruleSet.product_group_when,
              product_group_then: ruleSet.product_group_then,
              scope: ruleSet.scope,
              then: rule.then,
              when: rule.when
            });
          }
        });
      }
      return accu;
    }, []);
  };
};

const getRulesForFn = createSelector([getRuleSets], getRulesForFnSelector);

export const getSubLineItemsForScopeFn = createSelector(
  [getSubLineItems],
  subLineItems => {
    return (scope, other, productGroupId) => {
      return subLineItems.filter(sli => {
        return (
          sli[`${scope}_id`] == other[`${scope}_id`] &&
          sli.product_group_id === productGroupId &&
          (!sli.isOptional || (sli.isConfigurable && sli.isDecided)) &&
          !sli.isProgressed
        );
      });
    };
  }
);

/*
 * Given an proposed change (productId for subLineItemId) it returns the
 * list of required updates to the room book to keep valid in terms of
 * the rules.
 */
export const getRequiredUpdates = createSelector(
  [getRulesForFn, getSubLineItemsById, getSubLineItemsForScopeFn],
  (getRulesFor, subLineItemsById, getSubLineItemsForScope) => {
    return (subLineItemId, productId) => {
      const subLineItem = subLineItemsById[subLineItemId];
      const rules = getRulesFor(subLineItem.product_group_id, productId);

      const items = rules.reduce((accu, rule) => {
        const affected = getSubLineItemsForScope(
          rule.scope,
          subLineItem,
          rule.product_group_then
        );

        return affected.reduce((accu, item) => {
          if (
            !rule.then.product.id.includes(
              get(item, ["defactoSelectedOption", "id"])
            )
          ) {
            const productIds = item.isOptional ? [] : rule.then.product.id;
            const productOld = item.defactoSelectedOption;
            const productNew = item.options.find(o =>
              productIds.includes(o.id)
            );
            const totalOld = get(productOld, "total", 0);
            const totalNew = get(productNew, "total", 0);
            const totalChange = totalNew - totalOld;

            if (item.hasBuyerSelection || totalChange != 0) {
              accu.push({
                item,
                productIds,
                totalChange
              });
            }
          }
          return accu;
        }, accu);
      }, []);

      return {
        items,
        extraCosts: items
          .map(u => {
            return u.totalChange;
          })
          .reduce((sum, t) => {
            return sum + t;
          }, 0),
        extraCostsOnRequest: items.some(u => {
          return (
            get(u, ["item", "isOnRequest"], false) ||
            get(u, ["item", "productGroup", "quantity_on_request"], false)
          );
        })
      };
    };
  }
);
